// Format currency for display without decimals
export const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

// Helper function to calculate bid summaries for a sale
export const calculateSaleBidSummary = (saleItems = [], userBids = [], itemDetails = {}) => {
  const summary = {
    itemsBidCount: 0,
    totalOpeningPrice: 0,
    totalTopBid: 0,
    itemsWonCount: 0,
    wonOpeningPrice: 0,
    totalWonAmount: 0,
  };

  Object.values(saleItems).forEach((item, index) => {
    const bid = userBids[index];
    if (bid) {
      summary.itemsBidCount++;
      const openingPrice = Math.floor(Number(item.openingPrice) || 0);
      summary.totalOpeningPrice += openingPrice;
      const bidAmount = Math.floor(Number(bid.amount) || 0);
      summary.totalTopBid += bidAmount;

      if (bid.isWinning && item.status === 'sold') {
        summary.itemsWonCount++;
        summary.wonOpeningPrice += openingPrice;
        summary.totalWonAmount += Math.floor(Number(item.currentPrice) || 0);
      }
    }
  });
  return summary;
};

// Helper to prepare sale items data from groupedBids
export const prepareSaleItemsData = (groupedBids, itemDetails) => {
  return Object.values(groupedBids).map(lotData => ({
    id: lotData.item.uuid,
    openingPrice: Math.floor(itemDetails[lotData.item.uuid]?.startPrice) || 0,
    currentPrice: Math.floor(lotData.item.current_price) || 0,
    status: lotData.item.status
  }));
};

// Helper to prepare user bids data
export const prepareUserBidsData = (groupedBids) => {
  return Object.values(groupedBids).map(lotData => ({
    itemId: lotData.item.uuid,
    amount: Math.floor(lotData.bids[0]?.amount) || 0,
    isWinning: lotData.bids.some(bid => bid.id === lotData.item.winning_bid),
    status: lotData.item.status
  }));
};

// Component to display bid summary
export const BidSummaryDisplay = ({ summary, currency = 'USD', t }) => {
  return {
    itemsBidOn: `${summary.itemsBidCount} ${t('myBids.summary.items', { count: summary.itemsBidCount })}`,
    openingTotal: formatCurrency(summary.totalOpeningPrice, currency),
    topBidTotal: formatCurrency(summary.totalTopBid, currency),
    itemsWon: `${summary.itemsWonCount} ${t('myBids.summary.items', { count: summary.itemsWonCount })}`,
    wonOpeningTotal: formatCurrency(summary.wonOpeningPrice, currency),
    wonAmount: formatCurrency(summary.totalWonAmount, currency)
  };
};